module.exports = __webpack_public_path__ + "img/minus-circle.4ee32659.svg";